import React from "react";
import Layout from "@/Layout";
import { get } from "$ACTIONS/TlcRequest";
import { ApiPort } from "$ACTIONS/TLCAPI";
import { Carousel, Icon, Calendar, Skeleton, Button } from "antd";
import { PhotoProvider, PhotoConsumer } from "react-photo-view";
import { getStaticPropsFromStrapiSEOSetting } from "$DATA/seo";

export async function getStaticProps() {
	return await getStaticPropsFromStrapiSEOSetting('/sponsorship'); //參數帶本頁的路徑
}

const linkForMoreVids = "https://www.youtube.com/@FunsportThailand.V2";
const Sponsordata = [
    {
        title: "นิวคาสเซิลยูไนเต็ด",
        iconImagesUrl: "/th/img/sponsor/logo_nufc@2x.png",
        year: "2017 – ปัจจุบัน",
        className: "invert",
        style: {},
    },
    {
        title: "อิเกร์ กาซิยาส",
        iconImagesUrl: "/th/img/sponsor/Logo-Iker-1@2x.png",
        year: "2022 – ปัจจุบัน",
        className: "invert",
        style: {},
    },
    {
        title: "ท็อตแน่ม ฮ็อทสเปอร์",
        iconImagesUrl: "/th/img/sponsor/SPURS@2x.png",
        year: "2012 – 2024",
        className: "invert",
        style: {
            "navbtn-container": {
                gap: "0px",
            },
        },
    },
    {
        title: "โทนี่ ปาร์คเกอร์",
        iconImagesUrl: "/th/img/sponsor/logo_Tony.png",
        year: "2023 – 2024",
        className: "invert",
        style: {},
    },
    {
        title: "ทีม OG - DOTA 2",
        iconImagesUrl: "/th/img/sponsor/OG@2x.png",
        iconImagesUrlSelected: "/th/img/sponsor/OG-Selected.png",
        year: "2020 - 2022",
        className: "",
        style: {},
    },
    {
        title: "สตีฟ แนช",
        iconImagesUrl: "/th/img/sponsor/logo_steve@2x.png",
        year: "2015 – 2019",
        className: "invert",
        style: {},
    },
    {
        title: "รอบบี้ ฟาวเลอร์",
        iconImagesUrl: "/th/img/sponsor/logo_robbie@2x.png",
        year: "2014 – 2019",
        className: "invert",
        style: {},
    },
    {
        title: "โคบี ไบรอันต์",
        iconImagesUrl: "/th/img/sponsor/logo_kobe@2x.png",
        year: "2019 – 2020",
        className: "invert",
        style: {},
    },
    {
        title: "สโมสรฟุตบอล เบิร์นลีย์",
        iconImagesUrl: "/th/img/sponsor/logo_burnley.png",
        iconImagesUrlSelected: "/th/img/sponsor/Burnley-Selected.png",
        year: "2014 - 2016",
        className: "",
        style: {},
    },
    {
        title: "สโมสรฟุตบอล เบิร์นลีย์",
        iconImagesUrl: "/th/img/sponsor/logo_burnley.png",
        iconImagesUrlSelected: "/th/img/sponsor/Burnley-Selected.png",
        year: "2010 – 2012",
        className: "",
        style: {},
    },
];
const Carouseldata = [
    {
        id: 13575,
        style: {
            content: {
                marginTop: "23px",
            },
            header: {
                lineHeight: "1.4",
            },
        },
        bannerImageUrl: "/th/img/sponsor/Banner_NUFC.jpg",
        name: "นิวคาสเซิล ยูไนเต็ด", //纽卡斯尔联足球俱乐部
        title: "ผู้สนับสนุนหลักอย่างเป็นทางการ",
        content: (
            <>
                <p>
                    FUN88 เป็นสปอนเซอร์ติดหน้าอกเสื้อของทัพ 'สาลิกาดง' ตั้งแต่ปี 2017 ถึง 2023 ก่อนผันตัวเองมาเป็นพันธมิตรทางการในเอเชียตั้งแต่ปี 2023 จนถึงปัจจุบัน อีกทั้ง FUN88 ยังเป็นผู้นำในการสร้างกิจกรรมและฐานแฟนคลับให้กับ นิวคาสเซิล ติดต่อกันเป็นเวลาหลายปี
                </p>
                <p>
                    ความร่วมมือนี้ได้สร้างชื่อเสียงให้กับทั้งสององค์กรในวงการฟุตบอลด้วยผลงานที่โดดเด่น และขยายผลสำเร็จอย่างกว้างขวางมาตลอด พร้อมกับเป็นส่วนหนึ่งในหน้าประวัติศาสตร์ ของกันและกัน เฉกเช่นที่ นิวคาสเซิล ได้แชมป์ฟุตบอลลีก คัพ ของ อังกฤษ ในปี 2025 นี้เอง
                </p>
            </>
        ),
        otherImagesUrl: [
            "/th/img/sponsor/NUFC-Gallery-1.png",
            "/th/img/sponsor/NUFC-Gallery-2.png",
            "/th/img/sponsor/NUFC-Gallery-3.png",
        ],
        redirect: "", //https://www.nufc.co.uk/news/latest-news/fun88-becomes-newcastle-united-shirt-sponsor/
        contentOfRedirect: "", //进入纽卡斯尔官网
    },
    {
        id: 13573,
        style: {},
        bannerImageUrl: "/th/img/sponsor/Banner_IKER.jpg",
        name: "อิเกร์ กาซิยาส", //伊克尔·卡西利亚斯
        title: "ตำนานผู้รักษาประตูแชมป์ฟุตบอลโลก",
        content: (
            <>
                <p>
                    กัปตันทีมชาติสเปนผู้พาทีมคว้าแชมป์ฟุตบอลโลก 2010 และ แชมป์ ยูโร 2008 และยูโร 2012 เช่นเดียวกับ แชมป์ยูฟ่า แชมเปี้ยนส์ลีก, ลาลีก้า สเปน และรางวัลอื่นอีกมากมาย
                </p>
                <p>
                    “ผมตื่นเต้นที่จะได้เป็นตัวแทนของ FUN88 พวกเขาได้สร้างแบรนด์ที่สอดคล้องกับประวัติศาสตร์ ฟุตบอลและความหลงใหลในกีฬาฟุตบอล โดยรวมเอาความสนุกของกีฬาผสมผสานกับความ บันเทิงในรูปแบบเดียวกันเพื่อคุณโดยเฉพาะ” กาซิยาสกล่าวในวันเปิดตัวกับ FUN88
                </p>
            </>
        ),
        otherImagesUrl: [
            "/th/img/sponsor/IKER-Gallery-1.png",
            "/th/img/sponsor/IKER-Gallery-2.png",
            "/th/img/sponsor/IKER-Gallery-3.png",
        ],
        redirect: "",
        contentOfRedirect: "",
    },
    {
        id: 13576,
        style: {
            content: {
                marginTop: "40px",
            },
            header: {
                lineHeight: "1.4",
            },
        },
        bannerImageUrl: "/th/img/sponsor/Banner_SPURS.jpg",
        name: "ท็อตแน่ม ฮ็อทสเปอร์", //托特纳姆热刺足球俱乐部
        title: "พันธมิตรทางการในเอเชีย",
        content: (
            <>
                <p>
                    สเปอร์ส และ FUN88 จับมือกันเป็นผู้นำวงการลูกหนังโลกในการสร้างตำนานทั้งในสนามและ นอกสนามเป็นเวลา 12 ปีติดต่อกัน โดยในทศวรรษที่ผ่านมา สเปอร์ส ได้สร้างความทรงจำ และเรื่องราวมากมายในฟุตบอลรายการใหญ่ ๆ ทั้ง พรีเมียร์ลีก และ ยูฟ่า แชมเปียนส์ ลีก อย่างต่อเนื่อง ซึ่งถือเป็นการร่วมมือกันในการสร้างภาพลักษณ์ที่ดีสำหรับสององค์กรมาตลอด และเป็นการก้าวผ่านไปสู่อนาคตที่สดใสและยั่งยืน
                </p>
            </>
        ),
        otherImagesUrl: [
            "/th/img/sponsor/SPURS-Gallery-1.png",
            "/th/img/sponsor/SPURS-Gallery-2.png",
            "/th/img/sponsor/SPURS-Gallery-3.png",
        ],
        redirect: "", //https://www.tottenhamhotspur.com/may-article-import/2018/tottenham-hotspur-extends-relationship-with-fun88/
        contentOfRedirect: "", //进入托特纳姆热刺官网
    },
    {
        id: 13572,
        style: {},
        bannerImageUrl: "/th/img/sponsor/Banner_TONY.jpg",
        name: "โทนี่ ปาร์คเกอร์", //托尼·帕克
        title: "หนึ่งในนักบาสเกตบอลที่เก่งที่สุดตลอดกาลของทวีปยุโรป",
        content: (
            <div style={{fontSize: '13px'}}>
                <p>
                    โทนี่ ปาร์คเกอร์ เคยเล่นให้กับทีมบาสเกตบอลชื่อดังใน NBA อย่างซานอันโตนิโอ สเปอร์ส
                    ทีมดังแห่ง NBA มาเป็นเวลาหลายปี พร้อมกับได้รับรางวัลมากมาย อาทิ แชมป์ NBA 4 สมัย,
                    รางวัลผู้เล่นทรงคุณค่าแห่งรอบชิงชนะเลิศ NBA (NBA Finals MVP) 1 ครั้ง, การติดทีม 
                    NBA All-Star 6 ครั้ง, การติดทีมออล-NBA 4 ครั้ง และแชมป์ NBA All-Star Challenge 1 ครั้ง
                    นอกจากนี้ โทนี่ ปาร์คเกอร์ เป็นนักบาสเกตบอลต่างชาติคนแรกในประวัติศาสตร์
                    ที่คว้ารางวัล Finals MVP อีกด้วย
                </p>
                <p>
                ความสำเร็จอันโดดเด่นของปาร์คเกอร์ สะท้อนภาพลักษณ์ของแบรนด์ FUN88 
                และความมุ่งมั่นในการเป็นเลิศ ซึ่งเป็นสิ่งที่ปาร์คเกอร์รู้สึกเชื่อมโยงด้วยอย่างลึกซึ้ง
                นำไปสู่การตัดสินใจร่วมงานกับ FUN88 ในฐานะพันธมิตร i-gaming รายแรกของเขา
                </p>
            </div>
        ),
        otherImagesUrl: [
            "/th/img/sponsor/TonyParker-Gallery-1.jpg",
            "/th/img/sponsor/TonyParker-Gallery-2.jpg",
            "/th/img/sponsor/TonyParker-Gallery-3.jpg",
        ],
        redirect: "",
        contentOfRedirect: "",
    },
    {
        id: 13580,
        style: {
            content: {
                marginTop: "21px",
            },
        },
        bannerImageUrl: "/th/img/sponsor/Banner_OG.jpg",
        name: "OG - DOTA 2",
        title: "ผู้สนับสนุนหลักอย่างเป็นทางการ",
        content: (
            <div style={{fontSize: '13px'}}>
                <p>
                    FUN88 บุกเบิกวงการอีสปอร์ตด้วยการเป็นหุ้นส่วนอย่างเป็นทางการระดับโลกกับทีม OG - Dota 2
                </p>
                <p>
                    OG - Dota 2 อีสปอร์ตทีมชื่อดัง ได้จับมือร่วมเป็นหุ้นส่วนอย่างเป็นทางการกับ FUN88 
                    <br />
                    ซึ่ง OG - Dota 2 เป็นทีมแรกและทีมเดียวที่คว้าแชมป์ Dota 2 The International 
                    <br />
                    Championship ถึง 2 ครั้ง อีกทั้งยังได้รับชัยชนะเป็นทีมแรกในการแข่งขัน Dota 2 Valve Major ติดต่อกันถึง 4 ครั้ง
                </p>
            </div>
        ),
        otherImagesUrl: [
            "/th/img/sponsor/OG-Gallery-1.jpg",
            "/th/img/sponsor/OG-Gallery-2.jpg",
            "/th/img/sponsor/OG-Gallery-3.jpg",
        ],
        redirect: "",
        contentOfRedirect: "",
    },
    {
        id: 13578,
        style: {
            content: {
                marginTop: "63px",
            },
        },
        bannerImageUrl: "/th/img/sponsor/Banner_STEVE.jpg",
        name: "สตีฟ แนช", //史蒂夫·納什
        title: "อดีตผู้เล่นทรงคุณค่า NBA 2 สมัย",
        content: (
            <>
                <p>
                    ตำนานนักบาสเกตบอลผู้คว้ารางวัลผู้เล่นทรงคุณค่า (MVP) 
                    <br />
                    แห่งลีกบาสเกตบอลที่ดีที่สุดในโลกถึง 2 สมัย และยังได้รับเลือกให้ติดทีม NBA All-Time 
                    <br/>
                    ความร่วมมือของเขากับ FUN88 ถือเป็นการจับมือกันที่ทรงพลังและเป็นตำนานอย่างแท้จริง
                </p>
            </>
        ),
        otherImagesUrl: [],
        redirect: "",
        contentOfRedirect: "",
    },
    {
        id: 13579,
        style: {
            content: {
                marginTop: "63px",
            },
        },
        bannerImageUrl: "/th/img/sponsor/Banner_ROBBIE.jpg",
        name: "ร็อบบี้ ฟาวเลอร์",
        title: "กองหน้าระดับตำนานของ ลิเวอร์พูล",
        content: (
            <>
                <p>
                แข้งดังเจ้าของฉายา 'เดอะ ก็อด' ของแฟนลิเวอร์พูล เคยรับหน้าที่แบรนด์แอมบาสเดอร์ของ FUN88 เช่นกัน พร้อมกับสร้างประสบการณ์และความทรงจำดี ๆ ให้กับสมาชิกของ FUN88 เสมอมา
                </p>
            </>
        ),
        otherImagesUrl: [],
        redirect: "",
        contentOfRedirect: "",
    },
    {
        id: 13574,
        style: {},
        bannerImageUrl: "/th/img/sponsor/Banner_KOBE.jpg",
        name: "โคบี ไบรอันต์", //科比·布莱恩特
        title: "ตำนานนักบาสเกตบอล NBA",
        content: (
            <div style={{fontSize: '12px'}}>
                <p>หนึ่งในผู้เล่นที่ยิ่งใหญ่ที่สุดในประวัติศาสตร์ NBA มืออาชีพ โคบี ไบรอันต์ นั้นไม่ธรรมดา
                    เขาคือแชมป์ NBA 5 สมัย, 18 สมัยในทีม All-Star, ผู้เล่นทรงคุณค่าของ NBA ประจำปี 2008
                    และ MVP ของรอบชิงชนะเลิศสองครั้ง การทำแต้ม 81 คะแนนในเกมเดียวของเขายังคง
                    เป็นหนึ่งในผลงานที่ยิ่งใหญ่ที่สุดในประวัติศาสตร์บาสเกตบอล นอกเหนือจากสถิติแล้ว
                    ความมุ่งมั่นที่ไม่มีที่สิ้นสุดและจรรยาบรรณในการทำงานที่ไม่มีการประนีประนอม 
                    ทำให้โคบีเป็นสัญลักษณ์ของแรงบันดาลใจในระดับโลกที่เกินกว่าพื้นที่สนามบาส
                </p>
                <p>
                    ในปี 2019, FUN88 ได้บรรลุจุดสำคัญด้วยการแต่งตั้ง โคบี ไบรอันต์ เป็นแบรนด์แอมบาสเดอร์
                    ระดับโลกอย่างเป็นทางการ การร่วมมือครั้งนี้เป็นการผสานพลังระหว่างแพลตฟอร์ม
                    ความบันเทิงระดับโลกและนักกีฬาที่ยิ่งใหญ่ที่สุดในประวัติศาสตร์
                </p>
                <p>
                    "รู้สึกตื่นเต้นและดีใจเป็นอย่างมากที่ได้มีโอกาสร่วมงานกับ FUN88 และสิ่งที่เค้าตื่นเต้นมากที่สุดคือ
                    การทำฝันของคุณให้เป็นจริง" โคบี้ ไบรอันท์ เปิดใจในวันเปิดตัวกับ FUN88
                </p>
            </div>
        ),
        otherImagesUrl: [
            "/th/img/sponsor/KOBE-Gallery-1.png",
            "/th/img/sponsor/KOBE-Gallery-2.png",
            "/th/img/sponsor/KOBE-Gallery-3.png",
        ],
        redirect: "",
        contentOfRedirect: "",
    },
    {
        id: 13577,
        style: {},
        bannerImageUrl: "/th/img/sponsor/Banner_BURNLEY.jpg",
        name: "เบิร์นลีย์", //伯恩利足球俱樂部
        title: "ผู้สนับสนุนหลักอย่างเป็นทางการ",
        content: (
            <>
                <p>หลังจากที่ FUN88 เป็นพันธมิตรทางการของ เบิร์นลี่ย์ ในช่วงระหว่างปี 2010 ถึง 2012 แล้ว
                    ต่อมา FUN88 กลายเป็นผู้สนับสนุนเสื้ออย่างเป็นทางการของ เบิร์นลี่ย์ ในปี 2015 โดย 
                    เบิร์นลี่ย์ ถือเป็นสโมสรฟุตบอลทีมแรกมีโลโก้ FUN88 ติดหน้าอกเสื้อพร้อมได้ออกไปสู่
                    สายตาชาวโลกอย่างแพร่หลาย
                </p>
                <p>
                    ในช่วงเวลาที่ เบิร์ยลี่ย์ จับมือกับ FUN88 สโมสรก็ประสบความสำเร็จอย่างยิ่งใหญ่ด้วยการ
                    คว้าแชมป์ "เดอะ แชมเปียนส์ ชิพ อังกฤษ" ซึ่งหมายความว่า ทั้งสององค์กรร่วมกันเพื่อ
                    เป็นผู้นำกีฬาออนไลน์และก้าวข้ามจุดสูงสุดในระดับสากลมาในช่วงเวลาดังกล่าว
                </p>
            </>
        ),
        otherImagesUrl: [
            "/th/img/sponsor/BURNLEY-Gallery-1.png",
            "/th/img/sponsor/BURNLEY-Gallery-2.png",
            "/th/img/sponsor/BURNLEY-Gallery-3.png",
        ],
        redirect: "",
        contentOfRedirect: "",
    },
    {
        id: 13577,
        style: {},
        bannerImageUrl: "/th/img/sponsor/Banner_BURNLEY.jpg",
        name: "เบิร์นลีย์", //伯恩利足球俱樂部
        title: "ผู้สนับสนุนหลักอย่างเป็นทางการ",
        content: (
            <>
                <p>หลังจากที่ FUN88 เป็นพันธมิตรทางการของ เบิร์นลี่ย์ ในช่วงระหว่างปี 2010 ถึง 2012 แล้ว
                    ต่อมา FUN88 กลายเป็นผู้สนับสนุนเสื้ออย่างเป็นทางการของ เบิร์นลี่ย์ ในปี 2015 โดย 
                    เบิร์นลี่ย์ ถือเป็นสโมสรฟุตบอลทีมแรกมีโลโก้ FUN88 ติดหน้าอกเสื้อพร้อมได้ออกไปสู่
                    สายตาชาวโลกอย่างแพร่หลาย
                </p>
                <p>
                    ในช่วงเวลาที่ เบิร์ยลี่ย์ จับมือกับ FUN88 สโมสรก็ประสบความสำเร็จอย่างยิ่งใหญ่ด้วยการ
                    คว้าแชมป์ "เดอะ แชมเปียนส์ ชิพ อังกฤษ" ซึ่งหมายความว่า ทั้งสององค์กรร่วมกันเพื่อ
                    เป็นผู้นำกีฬาออนไลน์และก้าวข้ามจุดสูงสุดในระดับสากลมาในช่วงเวลาดังกล่าว
                </p>
            </>
        ),
        otherImagesUrl: [
            "/th/img/sponsor/BURNLEY-Gallery-1.png",
            "/th/img/sponsor/BURNLEY-Gallery-2.png",
            "/th/img/sponsor/BURNLEY-Gallery-3.png",
        ],
        redirect: "",
        contentOfRedirect: "",
    },
];

export class Carouselbox extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            indexOfCurrentSponsorPage: this.props.index,
        };
    }

    onChange(a, b, c) {
        console.log(a, b, c);
    }

    // ImageView() {
    //   return (
    //     <PhotoProvider>
    //       {this.props.Carouseldata.otherImagesUrl != "" &&
    //         this.props.Carouseldata.otherImagesUrl.map((item, index) => (
    //           <PhotoConsumer key={index} src={item} intro={item}>
    //             <div className="small_box">
    //               <div className="change_big">点击查看大图</div>
    //               <img
    //                 src={item}
    //                 alt=""
    //                 style={{ width: "140px", height: "90px" }}
    //               />
    //             </div>
    //           </PhotoConsumer>
    //         ))}
    //     </PhotoProvider>
    //   );
    // }

    ImageView(urls) {
        return (
            <PhotoProvider>
                {urls.length != 0 &&
                    urls.map((item, index) => (
                        <PhotoConsumer key={index} src={item}>
                            <div className="small_box">
                                <div className="change_big">
                                    คลิกเพื่อดูภาพขนาดใหญ่
                                </div>
                                {/* 点击查看大图 */}
                                <img
                                    src={item}
                                    alt=""
                                    style={{ width: "140px", height: "90px" }}
                                />
                            </div>
                        </PhotoConsumer>
                    ))}
            </PhotoProvider>
        );
    }

    render() {
        const { indexOfCurrentSponsorPage } = this.state;
        const data = Carouseldata[indexOfCurrentSponsorPage];

        return (
            <div>
                <Carousel afterChange={() => this.onChange} ref={"Carousel"}>
                    <div>
                        <div className="content" key={data.id}>
                            <div className="banner_left">
                                <img src={data.bannerImageUrl} />
                            </div>
                            <div className="banner_right">
                                <div
                                    className="banner_right__sponsorHeader"
                                    style={data.style.header}
                                >
                                    <div className="banner_right__sponsorHeader-name">
                                        {data.name}
                                    </div>
                                    <div className="banner_right__sponsorHeader-title">
                                        {data.title}
                                    </div>
                                </div>
                                <div
                                    className="banner_right__sponsorBody"
                                    style={data.style.content}
                                >
                                    <div
                                        className={
                                            "banner_right__sponsorBody-content"
                                        }
                                        // dangerouslySetInnerHTML={{ __html: data.content }}
                                    >
                                        {data.content}
                                    </div>
                                </div>
                                {data.redirect.trim().length != 0 && (
                                    <Button
                                        className="redirect-to-sponsor"
                                        href={data.redirect}
                                        target="_blank"
                                    >
                                        {data.contentOfRedirect}
                                    </Button>
                                )}
                                <div className="small_banner">
                                    {this.ImageView(data.otherImagesUrl)}
                                </div>
                            </div>
                        </div>
                    </div>
                </Carousel>
            </div>
        );
    }
}
import Router from "next/router";

export default class Main extends React.Component {
    constructor(props) {
        super(props);

        this.sponsortopRef = React.createRef();
        this.state = {
            topactive: 0,
            xCoordOfSponsortop: 0,
            distance: 0,
            // Sponsordata: [],
        };
    }

    componentDidMount() {
        const sponsortop = this.sponsortopRef.current;
        const distance =
            sponsortop.scrollWidth - sponsortop.getBoundingClientRect().width;

        this.setState({ distance });
    }

    Changetopnav(key) {
        this.setState({
            topactive: key,
        });
    }

    slide = (direction) => {
        const sponsortop = this.sponsortopRef.current;
        const { xCoordOfSponsortop, distance } = this.state;
        const oneClick = 218 + 20; // tab width + gap = 238
        let slidedDistance;

        if (direction === "next") {
            slidedDistance = xCoordOfSponsortop - oneClick;
            if (slidedDistance * -1 >= distance) {
                // negative to positive
                slidedDistance = distance * -1; // change back to negatice
            }
        }
        if (direction === "prev") {
            slidedDistance = xCoordOfSponsortop + oneClick;
            if (slidedDistance >= 0) {
                slidedDistance = 0;
            }
        }

        this.setState({ xCoordOfSponsortop: slidedDistance });
        sponsortop.style.left = slidedDistance + "px";
    };

    render() {
        const { topactive, xCoordOfSponsortop, distance } = this.state;

        console.log("dis: ", distance);
        console.log("xCoord: ", xCoordOfSponsortop);

        return (
            <Layout
                seoData={this.props.seoData}
                showFooter={false}
                status={1}
            >
                <div className="common-distance-wrap">
                    <div className="common-distance Sponsorbox">
                        {/* {Sponsordata == "" && <Skeleton active paragraph={{ rows: 1 }} />} */}
                        <div className="top-container">
                            {xCoordOfSponsortop != 0 && (
                                <Button
                                    className="Sponsortop-left-arrow-btn"
                                    onClick={this.slide.bind(this, "prev")}
                                >
                                    <img src="/th/img/sponsor/arrow-left.svg" />
                                </Button>
                            )}
                            <div className="Sponsortop">
                                <div className="Sponsortop-container">
                                    <ul ref={this.sponsortopRef}>
                                        {Sponsordata.map((item, index) => {
                                            return (
                                                <li
                                                    onClick={() => {
                                                        this.setState({
                                                            topactive: index,
                                                        });
                                                    }}
                                                    key={index}
                                                >
                                                    <div
                                                        className={
                                                            topactive == index
                                                                ? "active navbtn"
                                                                : `navbtn ${item.className}`
                                                        }
                                                    >
                                                        <div
                                                            className="navbtn-container"
                                                            style={
                                                                item.style[
                                                                    "navbtn-container"
                                                                ]
                                                            }
                                                        >
                                                            <img
                                                                src={
                                                                    topactive ===
                                                                        index &&
                                                                    item.iconImagesUrlSelected
                                                                        ? item.iconImagesUrlSelected
                                                                        : item.iconImagesUrl
                                                                }
                                                                style={
                                                                    item.style
                                                                        .img
                                                                }
                                                            />
                                                            <div className="navbtn-content">
                                                                <div className="navbtn-content__year">
                                                                    {item.year}
                                                                </div>
                                                                <div className="navbtn-content__title">
                                                                    {item.title}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>
                                            );
                                        })}
                                    </ul>
                                </div>
                            </div>
                            {xCoordOfSponsortop * -1 < distance && (
                                <Button
                                    className="Sponsortop-right-arrow-btn"
                                    onClick={this.slide.bind(this, "next")}
                                >
                                    <img src="/th/img/sponsor/arrow-right.svg" />
                                </Button>
                            )}
                        </div>
                        <div className="Sponsorbottom">
                            {Sponsordata != "" &&
                                Sponsordata.map((item, index) => {
                                    return (
                                        topactive == index && (
                                            <Carouselbox
                                                Carouseldata={item}
                                                keys={index}
                                                key={index}
                                                index={index}
                                            />
                                        )
                                    );
                                })}
                        </div>
                    </div>
                    {/* <Button
                        className="more-vids-btn"
                        href={linkForMoreVids}
                        target="_blank"
                    >
                        <div className="btn-content-container">
                            <img src="/th/img/sponsor/forMoreVidsYT@2x.png" />
                            <span>ดูวิดีโอเพิ่มเติม</span>
                        </div>
                    </Button> */}
                </div>
            </Layout>
        );
    }
}
